import _ from 'underscore';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { CustomColumnFormPanel } from '@bingads-webui-campaign-react/custom-column-form-panel';

export class CustomColumnBackboneWrapper extends Backbone.View {
  constructor(options) {
    super(options);
    this.props = _.defaults({
      onSave: (customColumn) => {
        if (_.result(options, 'props', {}).onSave) {
          options.props.onSave(customColumn);
        }
        this.remove();
      },
      onCancel: () => {
        if (_.result(options, 'props', {}).onCancel) {
          options.props.onCancel();
        }
        this.remove();
      },
    }, options.props);
  }

  render() {
    document.body.appendChild(this.el);
    ReactDOM.render(
      React.createElement(
        CustomColumnFormPanel,
        this.props
      ),
      this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
